export default "__VITE_ASSET__D5zynUtg__"